module.exports = __webpack_public_path__ + "assets/img/img-map-saga.e4f0ad0b.svg";